import InstagramTagInPostTriggerIntegrationInstructionsComponent from '@cohort/components-xps/components/apps/instagram/triggerIntegrations/tagInPost/InstructionsComponent';
import type {TriggerIntegration} from '@cohort/merchants/apps';
import useSocialStepCompletionColumns from '@cohort/merchants/apps/common/triggers/useSocialStepCompletionColumns';
import InstagramTagInPostTriggerIntegrationConfigComponent from '@cohort/merchants/apps/instagram/triggerIntegrations/tagInPost/ConfigComponent';
import InstagramTagInPostTriggerIntegrationStepCompletionsGridComponent from '@cohort/merchants/apps/instagram/triggerIntegrations/tagInPost/StepCompletionsGridComponent';
import InstagramTagInPostTriggerIntegrationStepCompletionTitleComponent from '@cohort/merchants/apps/instagram/triggerIntegrations/tagInPost/StepCompletionTitleComponent';
import type {InstagramTagInPostTriggerStruct} from '@cohort/shared/apps/instagram/triggers/tagInPost';
import {InstagramTagInPostTriggerIntegrationSpec} from '@cohort/shared/apps/instagram/triggers/tagInPost';

export const InstagramTagInPostTriggerIntegration: TriggerIntegration<InstagramTagInPostTriggerStruct> =
  {
    spec: InstagramTagInPostTriggerIntegrationSpec,
    configComponent: InstagramTagInPostTriggerIntegrationConfigComponent,
    stepCompletionTitleComponent: InstagramTagInPostTriggerIntegrationStepCompletionTitleComponent,
    stepCompletionsGridComponent: InstagramTagInPostTriggerIntegrationStepCompletionsGridComponent,
    stepCompletionContextComponent: undefined,
    useStepCompletionColumns: context =>
      useSocialStepCompletionColumns<InstagramTagInPostTriggerStruct>({
        ...context,
        userNameKey: 'username',
        getPostUrl: data => data.media?.permalink ?? null,
      }),
    getTitle: t => t('triggerIntegrations.tag-in-post.title', {ns: 'app-instagram'}),
    preview: {
      InstructionsComponent: InstagramTagInPostTriggerIntegrationInstructionsComponent,
    },
  };
